var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dot)?_c('span',{staticClass:"dot-status"},[_c('i',{staticClass:"dot-status-dot",style:({ background: _vm.dot.color })}),_vm._v(" "+_vm._s(_vm.$te(_vm.dot.text) ? _vm.$t(_vm.dot.text) : _vm.dot.text || '')+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }